import { FormInstance } from "antd/es/form";
import moment from "moment";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IKisi_Form_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IKisi_Form_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  GoBack: any;
  GoBack_dummy: any;
  AgirlikBaremListe: any[];
  AgirlikBaremListe_dummy: any[];
  SelectKisi: any[];
  SelectKisi_dummy: any[];
  Concat: string;
  Concat_dummy: string;
  SetValueOf: any;
  SetValueOf_dummy: any;
  SaveRecord_1: number;
  SaveRecord_1_dummy: number;
  SaveRecord_2: number;
  SaveRecord_2_dummy: number;
  isComp4630940Enabled: "enabled" | "disabled";
  isCompkisi_form_955508AuthorizationVisible: "visible" | "hidden";
}

export class Kisi_Form_ScreenBase extends React.PureComponent<
  IKisi_Form_ScreenProps,
  any
> {
  kisi_form_9595032_value_kuikaSelectBoxRef: React.RefObject<any>;
  ml = [
    {
      Id: "bd00ad4a-ed44-61e3-4813-27fcfc1bccc8",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "9f0b40ca-a5d3-4b72-bc52-230e83587430",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [],
    },
    {
      Id: "aae31bb4-5732-4bec-b543-1af38d683120",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 796540, PropertyName: "value", Value: "Kişi Formu" },
        { Id: 955508, PropertyName: "label", Value: "Tarihçe" },
        { Id: 7249851, PropertyName: "value", Value: "Ad" },
        { Id: 2149295, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 9084935, PropertyName: "value", Value: "Soyad" },
        { Id: 3489417, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 2508763, PropertyName: "value", Value: "AdSoyad" },
        { Id: 4630940, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 4157390, PropertyName: "value", Value: "CepTelefonu" },
        { Id: 1613070, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 7597293, PropertyName: "value", Value: "Eposta" },
        { Id: 5315539, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 1348640, PropertyName: "value", Value: "Kilo" },
        { Id: 9595032, PropertyName: "placeholder", Value: "Seçiniz..." },
        { Id: 1713048, PropertyName: "value", Value: "IsBakimci" },
        { Id: 1904518, PropertyName: "value", Value: "IsMurettebat" },
        { Id: 9772308, PropertyName: "value", Value: "IsYolcu" },
        { Id: 9544, PropertyName: "label", Value: "Kaydet" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);
    this.kisi_form_2149295_value_kuikaTextInputRef = React.createRef();
    this.kisi_form_3489417_value_kuikaTextInputRef = React.createRef();
    this.kisi_form_4630940_value_kuikaTextInputRef = React.createRef();
    this.kisi_form_1613070_value_kuikaTextInputRef = React.createRef();
    this.kisi_form_5315539_value_kuikaTextInputRef = React.createRef();
    this.kisi_form_9595032_value_kuikaSelectBoxRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      NAVIGATE: "",
      GoBack: "",
      AgirlikBaremListe: [],
      SelectKisi: [],
      Concat: "",
      SetValueOf: "",
      SaveRecord_1: 0,
      SaveRecord_2: 0,
      isComp4630940Enabled: "disabled",
      isCompkisi_form_955508AuthorizationVisible: "visible",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("kisi_form", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.Kisi_FormPageInit();
    }
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompkisi_form_955508AuthorizationVisible",
      ["41b245b2-8248-872c-382e-02ee2ce9c846", "FLYADMIN"]
    );

    KuikaAppManager.calculateAndSetBodyHeight("kisi_form", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("kisi_form", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.Kisi_FormPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      kisi_form_2149295_value: this.state.SelectKisi?.at?.(0)?.ad ?? undefined,
      kisi_form_3489417_value:
        this.state.SelectKisi?.at?.(0)?.soyad ?? undefined,
      kisi_form_4630940_value:
        this.state.SelectKisi?.at?.(0)?.adSoyad ?? undefined,
      kisi_form_1613070_value:
        this.state.SelectKisi?.at?.(0)?.cepTelefonu ?? undefined,
      kisi_form_5315539_value:
        this.state.SelectKisi?.at?.(0)?.eposta ?? undefined,
      kisi_form_9595032_value:
        this.state.SelectKisi?.at?.(0)?.kilo ?? undefined,
      kisi_form_2183386_value:
        this.state.SelectKisi?.at?.(0)?.isBakimci ?? undefined,
      kisi_form_7795559_value:
        this.state.SelectKisi?.at?.(0)?.isMurettebat ?? undefined,
      kisi_form_3313702_value:
        this.state.SelectKisi?.at?.(0)?.isYolcu ?? undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  Kisi_FormPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      Id_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Kisi_Form/Kisi_FormPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.AgirlikBaremListe = result?.data.agirlikBaremListe;

    formVars.kisi_form_9595032_value =
      stateVars.SelectKisi !== undefined
        ? stateVars.SelectKisi?.length > 0
          ? stateVars.SelectKisi[0].kilo
          : null
        : this.state.SelectKisi?.length > 0
        ? this.state.SelectKisi[0].kilo
        : null;
    formVars.kisi_form_9595032_options = stateVars.AgirlikBaremListe;
    stateVars.SelectKisi = result?.data.selectKisi;
    formVars.kisi_form_2149295_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectKisi !== undefined
        ? stateVars.SelectKisi?.length > 0
          ? stateVars.SelectKisi[0].ad
          : null
        : this.state.SelectKisi?.length > 0
        ? this.state.SelectKisi[0].ad
        : null
    );
    formVars.kisi_form_3489417_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectKisi !== undefined
        ? stateVars.SelectKisi?.length > 0
          ? stateVars.SelectKisi[0].soyad
          : null
        : this.state.SelectKisi?.length > 0
        ? this.state.SelectKisi[0].soyad
        : null
    );
    formVars.kisi_form_4630940_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectKisi !== undefined
        ? stateVars.SelectKisi?.length > 0
          ? stateVars.SelectKisi[0].adSoyad
          : null
        : this.state.SelectKisi?.length > 0
        ? this.state.SelectKisi[0].adSoyad
        : null
    );
    formVars.kisi_form_1613070_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectKisi !== undefined
        ? stateVars.SelectKisi?.length > 0
          ? stateVars.SelectKisi[0].cepTelefonu
          : null
        : this.state.SelectKisi?.length > 0
        ? this.state.SelectKisi[0].cepTelefonu
        : null
    );
    formVars.kisi_form_5315539_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectKisi !== undefined
        ? stateVars.SelectKisi?.length > 0
          ? stateVars.SelectKisi[0].eposta
          : null
        : this.state.SelectKisi?.length > 0
        ? this.state.SelectKisi[0].eposta
        : null
    );
    formVars.kisi_form_9595032_value =
      stateVars.SelectKisi !== undefined
        ? stateVars.SelectKisi?.length > 0
          ? stateVars.SelectKisi[0].kilo
          : null
        : this.state.SelectKisi?.length > 0
        ? this.state.SelectKisi[0].kilo
        : null;
    formVars.kisi_form_9595032_options = stateVars.AgirlikBaremListe;
    formVars.kisi_form_2183386_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectKisi !== undefined
        ? stateVars.SelectKisi?.length > 0
          ? stateVars.SelectKisi[0].isBakimci
          : null
        : this.state.SelectKisi?.length > 0
        ? this.state.SelectKisi[0].isBakimci
        : null
    );
    formVars.kisi_form_7795559_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectKisi !== undefined
        ? stateVars.SelectKisi?.length > 0
          ? stateVars.SelectKisi[0].isMurettebat
          : null
        : this.state.SelectKisi?.length > 0
        ? this.state.SelectKisi[0].isMurettebat
        : null
    );
    formVars.kisi_form_3313702_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectKisi !== undefined
        ? stateVars.SelectKisi?.length > 0
          ? stateVars.SelectKisi[0].isYolcu
          : null
        : this.state.SelectKisi?.length > 0
        ? this.state.SelectKisi[0].isYolcu
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.Kisi_FormPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  Kisi_FormPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.kisi_form_2149295_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectKisi !== undefined
        ? stateVars.SelectKisi?.length > 0
          ? stateVars.SelectKisi[0].ad
          : null
        : this.state.SelectKisi?.length > 0
        ? this.state.SelectKisi[0].ad
        : null
    );

    formVars.kisi_form_3489417_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectKisi !== undefined
        ? stateVars.SelectKisi?.length > 0
          ? stateVars.SelectKisi[0].soyad
          : null
        : this.state.SelectKisi?.length > 0
        ? this.state.SelectKisi[0].soyad
        : null
    );

    formVars.kisi_form_4630940_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectKisi !== undefined
        ? stateVars.SelectKisi?.length > 0
          ? stateVars.SelectKisi[0].adSoyad
          : null
        : this.state.SelectKisi?.length > 0
        ? this.state.SelectKisi[0].adSoyad
        : null
    );

    formVars.kisi_form_1613070_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectKisi !== undefined
        ? stateVars.SelectKisi?.length > 0
          ? stateVars.SelectKisi[0].cepTelefonu
          : null
        : this.state.SelectKisi?.length > 0
        ? this.state.SelectKisi[0].cepTelefonu
        : null
    );

    formVars.kisi_form_5315539_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectKisi !== undefined
        ? stateVars.SelectKisi?.length > 0
          ? stateVars.SelectKisi[0].eposta
          : null
        : this.state.SelectKisi?.length > 0
        ? this.state.SelectKisi[0].eposta
        : null
    );

    formVars.kisi_form_9595032_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectKisi !== undefined
        ? stateVars.SelectKisi?.length > 0
          ? stateVars.SelectKisi[0].kilo
          : null
        : this.state.SelectKisi?.length > 0
        ? this.state.SelectKisi[0].kilo
        : null
    );

    stateVars.dataSource_9595032 =
      stateVars.AgirlikBaremListe ?? this.state.AgirlikBaremListe;
    stateVars.dataSource_9595032 =
      stateVars.AgirlikBaremListe ?? this.state.AgirlikBaremListe;
    formVars.kisi_form_2183386_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectKisi !== undefined
        ? stateVars.SelectKisi?.length > 0
          ? stateVars.SelectKisi[0].isBakimci
          : null
        : this.state.SelectKisi?.length > 0
        ? this.state.SelectKisi[0].isBakimci
        : null
    );

    formVars.kisi_form_7795559_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectKisi !== undefined
        ? stateVars.SelectKisi?.length > 0
          ? stateVars.SelectKisi[0].isMurettebat
          : null
        : this.state.SelectKisi?.length > 0
        ? this.state.SelectKisi[0].isMurettebat
        : null
    );

    formVars.kisi_form_3313702_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectKisi !== undefined
        ? stateVars.SelectKisi?.length > 0
          ? stateVars.SelectKisi[0].isYolcu
          : null
        : this.state.SelectKisi?.length > 0
        ? this.state.SelectKisi[0].isYolcu
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  Kisi_FormComponent_955508_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "TarihceList",
      "MasterTablo",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("Fly.Kisi", "string"),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "TarihceList",
      "MasterId",
      ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "TarihceList",
      "Ekleyen",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.SelectKisi !== undefined
            ? stateVars.SelectKisi?.length > 0
              ? stateVars.SelectKisi[0].ekleyen
              : null
            : this.state.SelectKisi?.length > 0
            ? this.state.SelectKisi[0].ekleyen
            : null
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "TarihceList",
      "Degistiren",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.SelectKisi !== undefined
            ? stateVars.SelectKisi?.length > 0
              ? stateVars.SelectKisi[0].degistiren
              : null
            : this.state.SelectKisi?.length > 0
            ? this.state.SelectKisi[0].degistiren
            : null
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "TarihceList",
      "EklemeZamani",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.SelectKisi !== undefined
            ? stateVars.SelectKisi?.length > 0
              ? stateVars.SelectKisi[0].eklemeZamani
              : null
            : this.state.SelectKisi?.length > 0
            ? this.state.SelectKisi[0].eklemeZamani
            : null
        ),
        "Date"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "TarihceList",
      "DegistitirmeZamani",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.SelectKisi !== undefined
            ? stateVars.SelectKisi?.length > 0
              ? stateVars.SelectKisi[stateVars.SelectKisi.length - 1]
                  .degistirmeZamani
              : null
            : this.state.SelectKisi?.length > 0
            ? this.state.SelectKisi[this.state.SelectKisi.length - 1]
                .degistirmeZamani
            : null
        ),
        "Date"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "Kisi_Form",
      "TarihceList",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "415810",
      null,
      "right",
      "False",
      "100vw",
      "100vh",
      false,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  Kisi_FormComponent_968274_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  Kisi_FormComponent_3489417_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      s1_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "kisi_form_2149295_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      s2_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "kisi_form_3489417_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Kisi_Form/Kisi_FormComponent_3489417_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Concat = result?.data.concat;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.Kisi_FormComponent_3489417_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  Kisi_FormComponent_3489417_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "kisi_form_4630940_value",
        "string"
      ),
      ReactSystemFunctions.toString(this, this.state.Concat),
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  Kisi_FormComponent_9544_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      s1_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "kisi_form_2149295_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      s2_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "kisi_form_3489417_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Kisi_Form/Kisi_FormComponent_9544_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Concat = result?.data.concat;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.Kisi_FormComponent_9544_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  Kisi_FormComponent_9544_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "kisi_form_4630940_value",
        "string"
      ),
      ReactSystemFunctions.toString(this, this.state.Concat),
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.Kisi_FormComponent_9544_onClick2_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  Kisi_FormComponent_9544_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      Ad_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "kisi_form_2149295_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      AdSoyad_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "kisi_form_4630940_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      CepTelefonu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "kisi_form_1613070_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Eposta_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "kisi_form_5315539_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      IsBakimci_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "kisi_form_2183386_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
      IsMurettebat_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "kisi_form_7795559_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
      IsYolcu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "kisi_form_3313702_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
      Soyad_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "kisi_form_3489417_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Kilo_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "kisi_form_9595032_value",
            "value",
            "AgirlikBaremListe",
            "ad",
            "ad"
          )
        ),
        "string"
      ),
      EklemeZamani_0: ReactSystemFunctions.convertToTypeByName(
        moment().format("YYYY-MM-DDTHH:mm:ss"),
        "Date"
      ),
      Degistiren_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
      DegistirmeZamani_0: ReactSystemFunctions.convertToTypeByName(
        moment().format("YYYY-MM-DDTHH:mm:ss"),
        "Date"
      ),
      Ekleyen_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
    };

    if (
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.SelectKisi !== undefined
            ? stateVars.SelectKisi?.length > 0
              ? stateVars.SelectKisi[0].id
              : null
            : this.state.SelectKisi?.length > 0
            ? this.state.SelectKisi[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      )
    ) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "Kisi_Form/Kisi_FormComponent_9544_onClick2_",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.SaveRecord_1 = result?.data.saveRecord_1;
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.Kisi_FormComponent_9544_onClick3_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.Kisi_FormComponent_9544_onClick3_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  Kisi_FormComponent_9544_onClick3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      Ad_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "kisi_form_2149295_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      AdSoyad_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "kisi_form_4630940_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      CepTelefonu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "kisi_form_1613070_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Eposta_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "kisi_form_5315539_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      IsBakimci_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "kisi_form_2183386_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
      IsMurettebat_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "kisi_form_7795559_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
      IsYolcu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "kisi_form_3313702_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
      Soyad_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "kisi_form_3489417_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Kilo_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "kisi_form_9595032_value",
            "value",
            "AgirlikBaremListe",
            "ad",
            "ad"
          )
        ),
        "string"
      ),
      Degistiren_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
      DegistirmeZamani_0: ReactSystemFunctions.convertToTypeByName(
        moment().format("YYYY-MM-DDTHH:mm:ss"),
        "Date"
      ),
    };

    if (
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.SelectKisi !== undefined
            ? stateVars.SelectKisi?.length > 0
              ? stateVars.SelectKisi[0].id
              : null
            : this.state.SelectKisi?.length > 0
            ? this.state.SelectKisi[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      )
    ) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "Kisi_Form/Kisi_FormComponent_9544_onClick3_",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.SaveRecord_2 = result?.data.saveRecord_2;
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.Kisi_FormComponent_9544_onClick4_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.Kisi_FormComponent_9544_onClick4_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  Kisi_FormComponent_9544_onClick4_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.Kisi_FormPageInit();
    }
  }
}
